import { render, staticRenderFns } from "./teams-table.vue?vue&type=template&id=1f38690f&scoped=true&"
import script from "./teams-table.vue?vue&type=script&lang=js&"
export * from "./teams-table.vue?vue&type=script&lang=js&"
import style0 from "./teams-table.vue?vue&type=style&index=0&id=1f38690f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38690f",
  null
  
)

export default component.exports